import axiosInstance from './axiosInstance'

export const getCostProfitMatricesById = (id) => {
  return axiosInstance.get(`/cost-profit-matrices/${id}`)
}

export const getCostProfitMatricesByProjectId = (projectId) => {
  return axiosInstance.get(`/cost-profit-matrices/?projectId=${projectId}`)
}

// export const getCostProfitMatricess = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
//   return axiosInstance.get(`/cost-profit-matrices?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
// }

export const createCostProfitMatrices = (data) => {
  return axiosInstance.post('/cost-profit-matrices', data)
}

export const upsertCostProfitMatrices = (id, data) => {
  return axiosInstance.put(`/cost-profit-matrices/${id}`, data)
}

export const deleteCostProfitMatrices = (id) => {
  return axiosInstance.delete(`/cost-profit-matrices/${id}`)
}
